import { apiFetch, parseApiResponse } from '../../utils/apiClient';

const queryString = (params = {}) => new URLSearchParams(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
).toString();

export const searchQuoteCatalogProducts = async (params = {}) => {
  const query = queryString({ limit: 25, ...params });
  const response = await apiFetch(`/api/quote-catalog/materials${query ? `?${query}` : ''}`);
  return parseApiResponse(response);
};

export const getQuoteCatalogProduct = async (id) =>
  parseApiResponse(await apiFetch(`/api/quote-catalog/materials/${id}`));
